import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose, setPropTypes, withState, withHandlers } from 'recompose';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
// import ReactSelectMaterialUi from 'react-select-material-ui';
import ViewOrderList from '../../components/molecules/ViewOrderList';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import CancelButtonShop from '../../components/atoms/CancelButtonShop';
import RegisterButtonShop from '../../components/atoms/RegisterButtonShop';
import { sendLogin } from '../../auth/Auth';
import {
  getGochiMenus,
  getOrderGochiMenus,
  clearOrderGochiMenus,
  editOrderGochiMenus
} from '../../actions/GochiMenus';
import DragItemTypes from '../../constants/DragItemType';

const styles = {
  root: {
    position: 'absolute',
    width: '95%',
    maxWidth: '355px',
    height: 'auto',
    maxHeight: '80%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    backgroundColor: '#fff',
    // padding: 28,
    overflowY: 'scroll',
    outline: 'none',
    borderRadius: 4
  },
  pageTitle: {
    margin: '20px 20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    // color: '#707070',
    margin: '20px 0px 0px',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '24px'
  },
  mainPaper: {
    position: 'relative',
    width: '100%',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px',
    minHeight: '300px',
    boxShadow: 'none',
    borderRadius: 'initial',
    borderBottom: '1px solid #e0e0e0'
  },
  colorBlack: {
    color: 'rgba(0, 0, 0, 0.87)'
  },
  textTitle: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    marginRight: '5%'
  },
  inputBtn: {
    marginBottom: '10px',
    paddingLeft: '18px'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      shops: state.shops.shops,
      orderMenus: state.gochiMenus.orderMenus.menus
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          getOrderGochiMenus,
          clearOrderGochiMenus,
          editOrderGochiMenus
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openViewOrderProgress', 'updateOpenViewOrderProgress', false),
  withState('loading', 'updateLoading', false),
  withState('isViewOrderSuccess', 'updateIsViewOrderSuccess', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('orderMenuShopName', 'setOrderMenuShopName', ''),
  withState('orderItems', 'setOrderItems', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    createOrderItems: props => () => {
      const items = [];
      props.orderMenus.forEach(menu => {
        items.push({
          id: menu.menuId,
          name: menu.menuName
        });
      });
      props.setOrderItems(items);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions, // shops,
    checkSession,
    openViewOrderProgress,
    updateOpenViewOrderProgress,
    loading,
    updateLoading,
    isViewOrderSuccess,
    updateIsViewOrderSuccess,
    resultMessage,
    setResultMessage,
    createOrderItems,
    orderItems,
    setOrderItems,
    updateOpenViewOrderCustom,
    openViewOrderCustomList,
    updateOpenViewOrderCustomList,
    orderMenuShopId, // setOrderMenuShopId,
    searchKey,
    handleChangePage,
    isFukuoka
  }) => {
    const orderMenuSearchKey = {
      shopId: orderMenuShopId
    };

    useEffect(() => {
      const getOrderItems = async () => {
        if (!orderMenuShopId) {
          await actions.clearOrderGochiMenus();
        } else {
          await actions
            .getOrderGochiMenus(orderMenuSearchKey)
            .then(data => checkSession(data));
        }
        createOrderItems();
        updateOpenViewOrderCustomList(true);
      };
      getOrderItems();
    }, [orderMenuShopId]);

    // const getShopOptions = () => {
    //   const shopOptions = [];
    //   shops.forEach(shop => {
    //     shopOptions.push({ label: shop.shopName, value: String(shop.shopId) });
    //   });
    //   return shopOptions;
    // };

    const registerDisabled = !orderMenuShopId || orderItems.length === 0;

    const registerAction = async () => {
      const registerOrderItems = [];
      orderItems.forEach((item, index) => {
        registerOrderItems.push({
          menuId: item.id,
          viewOrder: index
        });
      });
      updateLoading(true);
      updateOpenViewOrderProgress(true);
      const editParam = {
        shopId: orderMenuShopId,
        orderMenus: registerOrderItems
      };
      const editedMenu = await actions
        .editOrderGochiMenus(editParam)
        .then(data => checkSession(data));
      if (editedMenu.type === 'EDIT_ORDER_GOCHI_MENU_SUCCESS') {
        updateIsViewOrderSuccess(true);
        actions.getGochiMenus(searchKey).then(data => checkSession(data));
        setResultMessage('変更が完了しました。');
        updateLoading(false);
      } else {
        updateIsViewOrderSuccess(false);
        setResultMessage('変更に失敗しました。');
        updateLoading(false);
      }
    };

    const cancelAction = () => {
      updateOpenViewOrderCustom(false);
      updateOpenViewOrderCustomList(false);
    };

    const progressOkAction = () => {
      if (isViewOrderSuccess) {
        updateOpenViewOrderCustom(false);
        updateOpenViewOrderCustomList(false);
        updateOpenViewOrderProgress(false);
        handleChangePage(null, 1, 10);
      } else {
        updateOpenViewOrderProgress(false);
      }
    };

    return (
      <div className={classes.root}>
        <div className={classes.pageTitle}>
          <Typography
            className={classNames(classes.textTitle, classes.colorBlack)}
          >
            {isFukuoka ? 'コース表示順変更' : 'メニュー表示順変更'}
          </Typography>
          <Typography
            className={classNames(classes.description, classes.colorBlack)}
          >
            {isFukuoka ? (
              <>
                コースをクリックして動かすことで、表示順を変更することができます。
                <br />
                登録ボタンを押すと変更内容が反映されます。
              </>
            ) : (
              <>
                店舗名を選択すると、その店舗のメニュー一覧が表示されます。
                <br />
                表示されたメニューをクリックして動かすことで、表示順を変更することができます。
                <br />
                変更後に登録ボタンで、変更内容が反映されます。
              </>
            )}
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          {/* <div>
            <ReactSelectMaterialUi
              required
              label="店舗名"
              className={classes.textField}
              defaultValue={String(orderMenuShopId)}
              options={getShopOptions()}
              margin="normal"
              onChange={v => {
                setOrderMenuShopId(Number(v));
              }}
              SelectProps={{
                isClearable: true,
                msgNoOptionsMatchFilter: '名前が部分一致する店舗がありません'
              }}
            />
          </div> */}
          {openViewOrderCustomList && (
            <ViewOrderList
              items={orderItems}
              setOrderItems={setOrderItems}
              itemType={DragItemTypes.MENU}
            />
          )}
        </Paper>
        <div className={classes.inputBtn}>
          <CancelButtonShop onClickAction={cancelAction} color="primary" />
          <RegisterButtonShop
            onClickAction={registerAction}
            disabled={registerDisabled}
          />
        </div>
        <ProgressDialog
          openProgress={openViewOrderProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
